"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useElementId from "../../hooks/useElementId.js";
import { TabsProvider } from "./TabsContext.js";
const TabsControlled = (props) => {
    const { children, value, onChange, onSilentChange, itemWidth, variant, name, direction = "row", size = "medium", } = props;
    const id = useElementId();
    const elActiveRef = React.useRef(null);
    const elPrevActiveRef = React.useRef(elActiveRef.current);
    const elScrollableRef = React.useRef(null);
    const [selection, setSelection] = React.useState({
        scaleX: 0,
        scaleY: 0,
        left: 0,
        top: 0,
        status: "idle",
    });
    const setDefaultValue = (value) => {
        if (value === undefined)
            return;
        if (onSilentChange)
            onSilentChange({ value, name });
    };
    return (_jsx(TabsProvider, { value: {
            value,
            name,
            size,
            direction,
            itemWidth,
            variant,
            onChange,
            id,
            setDefaultValue,
            elActiveRef,
            elPrevActiveRef,
            elScrollableRef,
            selection,
            setSelection,
        }, children: children }));
};
TabsControlled.displayName = "TabsControlled";
export default TabsControlled;
